
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/superchat",
      function () {
        return require("private-next-pages/destinations/superchat.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/superchat"])
      });
    }
  